/** Client-side text search shared by list filters. */

/**
 * Whitespace-separated terms, all of which must match somewhere in the record.
 * Word order stops mattering, so "order status" finds "Check Order Status" and
 * anything filed under "Order Inquiry / Order status".
 */
export const searchTerms = (query: string): string[] => query.trim().toLowerCase().split(/\s+/).filter(Boolean);

export const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Every term present in the haystack. Caller decides which fields it spans. */
export const matchesAllTerms = (haystack: string, terms: string[]): boolean =>
	terms.every((term) => haystack.includes(term));

/**
 * Splits `text` into alternating plain and matched fragments. Terms are tried
 * longest first so "order status" marks as one phrase instead of fragmenting
 * into the shorter terms inside it.
 */
export const splitOnTerms = (text: string, terms: string[]): Array<{ text: string; match: boolean }> => {
	if (!terms.length) return [{ text, match: false }];
	const pattern = [...terms].sort((a, b) => b.length - a.length).map(escapeRegExp).join('|');
	const wanted = new Set(terms);
	return text
		.split(new RegExp(`(${pattern})`, 'gi'))
		.filter((part) => part !== '')
		.map((part) => ({ text: part, match: wanted.has(part.toLowerCase()) }));
};
